import React from 'react'

import docService from '../services/shared.document.service'
import SharedLoginModal from "../commons/SharedLoginModal";
import PublicLayout from "../layout/PublicLayout";

class SharedDocumentView extends React.Component {

  constructor(props) {
    super(props)
      this.state = {
        error: null,
        showLoginModal: true,
        token: null,
      }
  }

  componentDidMount() {
      console.log("location:", this.props.location.pathname);
      const pathname = this.props.location.pathname;
      const idx = pathname.lastIndexOf('/');
      const token = pathname.substr(idx + 1);
      this.setState({token: token})
      console.log("token:", token);

      docService.checkToken(token).then(
          (rsp) =>{
              const url = `/axiom/share/doc/download/${token}`
              window.location.href = url
              //window.open(url)
          }
      ).catch(err =>{
          this.setState({error: err})
      })
  }

    login = (username, password) => {
        docService.login(username, password)
            .then( rsp => {
                console.log('login rsp:', rsp)
                this.setState({showLoginModal: false, error: null})
                const url = `/axiom/share/doc/download/${this.state.token}?jwt=${rsp.jwt}`
                window.location.href = url
                //window.open(url)
            })
            .catch(err =>{
                this.setState({error: err, showLoginModal: false})
            })
    }

  render() {

      if (this.state.error && this.state.error.message === "401") {
          return (
              <PublicLayout>
                  <SharedLoginModal visible={this.state.showLoginModal} onSubmit={this.login} onCancel={() => {
                      this.setState({showLoginModal: false})
                  }}/>
              </PublicLayout>
          )
      }

      return (
          <PublicLayout></PublicLayout>
      )

  }
}

export default SharedDocumentView;
